import {
  Button,
  CircularProgress,
  Grid,
  TextField,
} from '@material-ui/core';

import NumberFormat from 'react-number-format';
import React from 'react';

const Form = (props) => {
  // value form control
  const {
    buttonText,
    buttonID,
    handleSubmit,
    isValid,
    handleChange,
    submitting,
    setFieldValue,
    message,
    errors,
    values: { firstName, lastName, phone },
  } = props;

  return (
    <div className='form-wrapper edit-info-form'>
      <form onSubmit={handleSubmit}>
        <Grid container spacing={3} justify='space-between'>
          <Grid item xs={12} sm={6}>
            <TextField
              id='firstName'
              name='firstName'
              variant='outlined'
              onChange={handleChange}
              error={Boolean(errors.firstName)}
              required
              defaultValue={firstName}
              margin='normal'
              fullWidth
              label='First name'
              placeholder='First Name'
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name='lastName'
              placeholder='Last Name'
              label='Last Name'
              onChange={handleChange}
              error={Boolean(errors.lastName)}
              required
              variant='outlined'
              defaultValue={lastName}
              margin='normal'
              fullWidth
            />
          </Grid>
        </Grid>
        <Grid container spacing={3} justify='space-between'>
          <Grid item xs={12} sm={6}>
            <NumberFormat
              customInput={TextField}
              format='(###) ###-####'
              allowEmptyFormatting
              mask='_'
              name='phone'
              placeholder='Phone'
              label='Phone'
              onValueChange={(e) => e.floatValue && setFieldValue('phone', e.floatValue.toString())} // use NumberFormat output to give true value for validation
              error={Boolean(errors.phone)}
              required
              variant='outlined'
              defaultValue={phone}
              margin='normal'
              fullWidth
            />
          </Grid>
        </Grid>
        <div className='form-controls'>
          <Button
            variant='contained'
            color='secondary'
            fullWidth
            type='submit'
            id={buttonID}
            disabled={!isValid || submitting === true}
          >
            {submitting === false ? buttonText : <CircularProgress size={20} />}
          </Button>
          {!message.hasMessage ? null : <p className='error'>{message.message}</p>}
        </div>
      </form>
    </div>
  );
};

export default Form;
